import { SET_MONEY_LOAN_HISTORY } from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MONEY_LOAN_HISTORY:
      return { ...state, ...action.value };
    default: return state;
  }
};
